import {
  AlternateSectionBlock,
  Media as MediaType,
} from "@/payload-types";
import { Media } from "@onclicks/sharedcomponents/Media/Media";
import RichText from "./RichText";
import { cn } from "@/utilities/ui";
import React from "react";
import { CMSLink } from "./CMSLink";

type ItemFromCMS = NonNullable<AlternateSectionBlock["items"]>[number];

interface AlternateItemProps {
  title?: ItemFromCMS["title"];
  text?: ItemFromCMS["content"];
  links?: ItemFromCMS["links"];
  media: MediaType | string | any;
  index: number;
}

export const AlternateItem: React.FC<AlternateItemProps> = ({
  title,
  text,
  media,
  links,
  index,
}) => {
  const isEven = index % 2 === 0;

  return (
    <div className="relative w-full overflow-hidden mt-10">
      {/* On garde la grille à 2 colonnes uniquement pour le desktop */}
      <div className="grid grid-cols-1 md:grid-cols-2 w-full items-center">
        {/* ZONE TEXTE */}
        <div
          className={cn(
            "z-10",
            isEven
              ? "md:order-1 text-left px-4 md:pl-14 lg:pl-32 md:pr-12"
              : "md:order-2 px-4 md:pr-14 lg:pr-32 md:pl-12 md:ml-auto",
          )}
        >
          <div className={cn("max-w-[65ch]")}>
            {title && <h2 className="mb-5 leading-tight text-3xl">{title}</h2>}
            <div>
              {text && (
                <RichText
                  data={text}
                  className="text-sm lg:text-xl"
                  enableProse={false}
                  enableGutter={false}
                />
              )}

              {links && (
                <ul className="p-0">
                  {links.map((link, i) => (
                    <li key={i} className="mt-8 list-none">
                      <CMSLink {...link.link} />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        {/* ZONE IMAGE DESKTOP */}
        <div
          className={cn(
            "hidden md:block relative w-[90%] z-0",
            isEven ? "md:order-2" : "md:order-1",
            // On réduit l'angle du clip-path (20% au lieu de 43%) pour ne pas couper le sujet
            isEven
              ? "md:[clip-path:polygon(57%_0%,100%_0%,100%_100%,0%_100%)] ml-auto"
              : "md:[clip-path:polygon(0%_0%,57%_0%,100%_100%,0%_100%)]",
            "aspect-video", // Définit la hauteur par rapport à la largeur
          )}
        >
          <Media
            resource={media}
            fill // IMPORTANT : l'image doit remplir le conteneur rogné
            imgClassName={cn(
              "w-full h-full object-cover",
              isEven ? "object-right" : "object-left",
            )}
            priority
          />
        </div>

        {/* IMAGE MOBILE (Placée ici pour sortir du flux grid 2 colonnes desktop) */}
        <div className="md:hidden w-full h-[350px] relative mt-5">
          <Media resource={media} fill imgClassName="object-contain" priority />
        </div>
      </div>
    </div>
  );
};
